import $ from './jquery-shim.js';

export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.newsTicker();
    this.showCookie();
    this.formModal();
    this.fixHeaderOnScroll();
    this.solutionPopModal();
    this.selectLanguage();
  }

  /**
   * カスタム関数
   */

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }
  // 複製して作業
  newsTicker() {
    var newsIndex = 0;
    var newsIndexMax = $(".c-block-news-ticker__block").length;

    if (newsIndexMax === 0) return;

    if (newsIndexMax <= 1) {
      $(".c-block-news-ticker__block").eq(0).addClass("is-active");
    } else {
      $(".c-block-news-ticker__block").eq(0).addClass("is-active");
      setInterval(function(){
        if (newsIndex < newsIndexMax - 1) {
          newsIndex = newsIndex + 1;
        }else{
          newsIndex = 0;
        }
        $(".c-block-news-ticker__block").removeClass("is-active");
        setTimeout(function(){
          $(".c-block-news-ticker__block").eq(newsIndex).addClass("is-active");
        },1200);
      },4000);
    }
  }

  showCookie() {
    const cookie = $("#cookie");
    const btn = $("#cookieBtn");

    if (!cookie.length || !btn.length) return;

    const isCookiePermitted = sessionStorage.getItem('session-cookie-permission');

    if (isCookiePermitted) {
      cookie.addClass("is-hidden");
      $("body").addClass("is-cookie-permitted");
      return;
    }

    btn.click(function (e) {
      e.preventDefault();
      sessionStorage.setItem('session-cookie-permission', true);
      cookie.addClass("is-hidden");
      $("body").addClass("is-cookie-permitted");
    });

    window.onscroll = function (e) {
      if (window.pageYOffset > 100) {
        cookie.addClass("is-fixed");
      } else {
        cookie.removeClass("is-fixed");
      }
    }
  }

  formModal() {
    const triggerbtn = $(".l-header__search,.l-header__sm-search");
    const closebtn = $(".c-block-modal-form__close");

    triggerbtn.click(function (e) {
      $("body").toggleClass("is-search-modal-open");
    })

    closebtn.click(function (e) {
      $("body").toggleClass("is-search-modal-open");
    })


    $(".c-block-modal-form__bg").click(function (e) {
      $("body").toggleClass("is-search-modal-open");
    })
  }

  selectLanguage() {
    const triggerbtn = $(".l-header__sm-language");
    const addclass = $(".c-block-language");
    const closebtn = $(".c-block-language__close");

    triggerbtn.click(function (e) {
      addclass.toggleClass("is-show");
    })

    closebtn.click(function (e) {
      addclass.toggleClass("is-show");
    })


    $(".c-block-language__bg").click(function (e) {
      addclass.toggleClass("is-show");
    })
  }

  fixHeaderOnScroll() {
    if (!$(".l-header").hasClass("is-top")) return;

    var position = 0;
    var border = 600;

    if (window.innerWidth < 950) {
      border = 400;
    }

    $(window).scroll(function (e) {
      var $element = $('.l-header');
      var $menu = $('.c-slidebar-button');
      var scrollTop = $(this).scrollTop();
      if (scrollTop <= 0) {
        $element.removeClass('hide').removeClass('is-white');
        $menu.removeClass('hide').removeClass('is-white');
      } else if (scrollTop < position) {
        $element.removeClass('hide');
        $menu.removeClass('hide');
      } else if (scrollTop > position) {
        $element.addClass('is-white');
        $menu.addClass('is-white');
        if (scrollTop + $(window).height() >= $(document).height() - $element.height()) {
          $element.removeClass('hide');
          $menu.removeClass('hide');
        } else if (Math.abs($element.position().top) < $element.height() && scrollTop > border) {

          $element.addClass('hide');
          $menu.addClass('hide');
        }
      }
      position = scrollTop;
    })
  }

  solutionPopModal() {
    let $target = $('.js-pop-item');

    if (!$target) {
      return false;
    }

    $target.find('.js-pop-trigger').on('click' , function () {
      $(this).parents('.js-pop-item').find('.js-pop-modal').addClass('is-open');
    });
    $('.c-box-here-pop__close').on('click' , function () {
      $(this).parent().parent().removeClass('is-open');
    });
    $('.c-box-here-pop__bg').on('click' , function () {
      $(this).parent().removeClass('is-open');
    });
  }
}




